import React from 'react';

const Contact = () => {
  const phone = '+233202208006';
  const email = 'singwiththevocalfactory@gmail.com';
  const sms = '+233202208006';

  return (
    <section>
      <h1>Contact Us</h1>
      <div style={{display:'grid', gridTemplateColumns:'1fr 320px', gap:16, marginTop:12}}>
        <div>
          <p>Want to book or request a quote? Reach out via any of the channels below.</p>

          <div style={{display:'flex', gap:10, flexWrap:'wrap', marginTop:12}}>
            <a className="btn" href={`https://wa.me/message/E6UXFZXB6RRZC1`} target="_blank" rel="noreferrer">WhatsApp</a>
            <a className="btn secondary" href={`mailto:${email}`}>Email</a>
            <a className="btn secondary" href={`tel:${phone}`}>Call</a>
            <a className="btn secondary" href={`sms:${sms}`}>SMS</a>
          </div>

          {/* <h3 style={{marginTop:20}}>Contact Form</h3>
          <form action="#" onSubmit={(e) => { e.preventDefault(); alert('Form submission placeholder — hook to backend.'); }}>
            <div style={{display:'grid', gap:8}}>
              <input required placeholder="Name" name="name" style={{padding:10,borderRadius:8,border:'1px solid rgba(255,255,255,0.06)', background:'transparent', color:'var(--text)'}} />
              <input required placeholder="Email" name="email" type="email" style={{padding:10,borderRadius:8,border:'1px solid rgba(255,255,255,0.06)', background:'transparent', color:'var(--text)'}} />
              <textarea placeholder="Message" rows="5" style={{padding:10,borderRadius:8,border:'1px solid rgba(255,255,255,0.06)', background:'transparent', color:'var(--text)'}} />
              <button className="btn" type="submit">Send</button>
            </div>
          </form> */}
        </div>

        {/* <aside className="card">
          <strong>Studio Hours</strong>
          <div style={{color:'var(--muted)', marginTop:8}}>Mon - Fri: 9am - 6pm</div>
          <div style={{color:'var(--muted)', marginTop:8}}>Address: 123 Voice Street, City</div>
        </aside> */}
      </div>
    </section>
  );
};

export default Contact;